import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Rating } from '@mui/material'
import { formChange } from '../../../reducers/form'

export default function StarChange({ formName }) {
  const dispatch = useDispatch()
  const star = useSelector(state => state.form[formName]?.values?.star || 0)
  const handleChange = (event, i) => {
    dispatch(formChange(i, { field: 'star', name: formName }))
  }
  return <Rating
    size="large"
    value={star}
    onChange={handleChange}
  />
}